import { Milestone } from '../../interfaces/question';
import {
    answersBulkSave,
    getMilestonesQuestions
} from '../../services/questions';
import Swal from 'sweetalert2';
import queryString from 'query-string';
import '../../styles/cuestionario.css';
import Loader from '../../components/Loader';
import { useEffect, useRef, useState } from 'react';
import { t, changeLanguage } from 'i18next';
import { useHistory } from 'react-router-dom';

// const DUMMY_PAYLOAD = {
//     "user_id" : 12877,
//     "instance_id" : 12347,
//     "instance_name":"Juana",
//     "instance_months" : 6,
//     "language": "es",
//     "program_name": "Afini Popoyan"
// }

// URL format: localhost:3000/hitos?user_id=12877&instance_id=12347&instance_name=Juana&instance_months=6&language=es&program_name=Afini%20Popoyan

const MilestonesCuestionario = () => {
    const queryParams = queryString.parse(window.location.search, {decode: true});
    const hasFetchData = useRef(false);
    const [loading, setLoading] = useState(true);
    const [stage, setStage] = useState<any>(null);
    const [milestones, setMilestones] = useState<Milestone[]>([]);
    const [instanceName, setInstanceName] = useState("");
    const [session, setSession] = useState("");
    const [, setDisableButtons] = useState(false);
    const navigate = useHistory();

    // useEffect(() => {
    //     setTimeout(()=> {
    //         setDisableButtons(false);
    //     },500)
    // },[milestones])

    useEffect(() => {
        const uri = window.location.href;
        localStorage.setItem("@uriHitos",uri);
        if(!hasFetchData.current) {
            changeLanguage(queryParams.language as string || 'es')
            getMilestonesQuestions(queryParams)
            .then( response => {
                if(response.milestones.length>0){
                    setMilestones(response.milestones);
                    setStage(response.stage);
                    setInstanceName(response.instance_name);
                    setSession(response.session);
                }
                setLoading(false);
            })
            .catch(err => {
                console.log(err);
                setLoading(false);
            })
            hasFetchData.current = true;
        }
    },[queryParams]);

    const handleSelect = async (current:Milestone, type:string) => {
        try{
            setDisableButtons(true);
            const newData = milestones.map((item:Milestone) =>
                item.milestone_config === current.milestone_config
                ? {...item, answer: (type === item.answer) ? null : type}
                : {...item}
            )
            setMilestones(newData);
            const payload = {
                session,
                answers: [{ milestone_config: current.milestone_config, value: type}]
            }
            await answersBulkSave(payload)
            setDisableButtons(false);
        } catch(err){
            console.error(err);
            await Swal.fire("",t('save_error'),"error");
            setDisableButtons(false);
        }
    }

    if (loading){
        return <Loader />
    }

    return (
        <>
            <div className="row">
                <div className="col-sm-6">
                    <div className="left-column">
                        <div style={{position:'absolute',top:'10px',left:'20px'}}>
                            <button className='btn btn-primary buttons' onClick={()=>navigate.goBack()}>regresar</button>
                        </div>
                        { stage && instanceName ?(
                            <div>
                                <h3 className="text-center">{instanceName}</h3>
                                <div style={{width: '15%', borderTop: '4px solid white', margin: '10px auto'}}></div>
                                <img src={stage.image_url} alt={instanceName}
                                style={{ display: 'block', margin: '5px auto', width: '65px', height: '65px', borderRadius: '50%' }}/>
                                <h5 className="text-center">{stage.name.toUpperCase()}</h5>
                            </div>
                        ) : (
                            <h3 className="text-center">{t('cant_get_info_error')}</h3>
                        )}
                    </div>
                </div>
                <div className="col-sm-6">
                    <div className="right-column">
                        {milestones.length === 0 ? (
                            <div style={{
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                flexDirection: 'column',
                                height: '100vh',
                                width: '100%'
                            }}>
                                <div className="alert alert-info">{t('without_data')}</div>
                            </div>
                        ) : (
                            milestones.map((item:Milestone, idx:number) => (
                                <div key={`${idx}-${item.milestone_config}`}>
                                    <p>{item.question}</p>
                                    <div className="row text-center">
                                        <div className="col-sm-4">
                                            <button
                                            className={`btn btn-outline-success buttons ${item.answer === 'done' && 'active'}`}
                                            onClick={() => handleSelect(item, 'done')}>{t('yes')}</button>
                                        </div>
                                        <div className="col-sm-4">
                                            <button
                                            className={`btn btn-outline-danger buttons ${item.answer === 'failed' && 'active'}`}
                                            onClick={() => handleSelect(item, 'failed')}>{t('no')}</button>
                                        </div>
                                        <div className="col-sm-4">
                                            <button
                                            className={`btn btn-outline-warning buttons ${item.answer === 'unknown' && 'active'}`}
                                            onClick={() => handleSelect(item, 'unknown')}>{t('i_dont_know')}</button>
                                        </div>
                                    </div>
                                    <div className="line"></div>
                                </div>
                            ))
                        )}
                    </div>
                </div>
            </div>
        </>
    )
}

export default MilestonesCuestionario
